/**
 * leader — the thread from a ring anchor to its float.
 *
 * Geometry only: it lives in the rotated leader layer in world coordinates, so
 * spinning the ring is still a single transform write. A quadratic bezier bent
 * through a point on the anchor ray just outside the ring makes the line leave
 * the ring radially and then curve toward the card, which is what makes a slid
 * float still read as attached to its date.
 *
 * `to` is the float's near edge, not its centre; where the card is not radially
 * aligned the last few pixels tuck under it, which is exactly what you want.
 */
import type { Fragment, LeaderCtx } from '../types';
import { n, svgEl } from '../../core/svg';

export const leaderFragment: Fragment<LeaderCtx> = (ctx, state) => {
  const hot = state.hover || state.selected;
  const colour = hot ? (ctx.colour ?? 'var(--accent)') : 'var(--leader)';
  const orphaned = Boolean(ctx.event?.orphanedAt);
  const d = `M ${n(ctx.from.x)} ${n(ctx.from.y)} Q ${n(ctx.bend.x)} ${n(ctx.bend.y)} ${n(ctx.to.x)} ${n(ctx.to.y)}`;

  return svgEl('g', { 'data-frag': 'leader', 'pointer-events': 'none' }, [
    svgEl('path', {
      d,
      fill: 'none',
      stroke: colour,
      'stroke-width': hot ? 1.6 : 1.1,
      'stroke-linecap': 'round',
      'vector-effect': 'non-scaling-stroke',
      opacity: orphaned ? 0.3 : hot ? 0.95 : 0.8,
      ...(state.pinned && !hot ? { 'stroke-dasharray': '3 3' } : {}),
    }),
  ]);
};
